<template>
  <div class="pay-method" v-if="showThis">
    <div class="header-box">
      <svg-icon @click="closeThis" name="Close" class="close" size="24px"></svg-icon>
    </div>
    <svg-icon name="Icon-Success" class="icon"></svg-icon>
    <div class="main_title">支付成功</div>
    <div class="vice_title">重新登录客户端，即可使用所有会员功能</div>
    <div class="return_box">
      <template v-if="props.needInvoice">
        <div class="btn" @click="closeThis">关闭</div>
        <router-link class="btn open_order" to="/personal/orderinfo">开具发票</router-link>
      </template>
      <div v-else class="btn" @click="closeThis">我知道了</div>
    </div>
    <div class="dashed-line"></div>
    <div class="code_box">
      <div class="code_title">扫码下载 CAD迷你看图手机APP</div>
      <figure class="down_app_code"></figure>
      <div class="code_intro">随时随地看图纸</div>
    </div>
  </div>
  <div class="mask" v-if="showThis"></div>
</template>

<script setup>
import { defineProps, defineEmits, toRefs } from 'vue'
import tool from '@/assets/js/tool'

/* --- props --- */
const props = defineProps({
  showThis: {
    type: Boolean
  },
  finalPrice: {},
  productInfo: {
    type: Object
  },
  needInvoice: {
    type: Boolean
  } // 是否需要开具发票按钮?
})
/* --- emit --- */
const emit = defineEmits(['update:showThis', 'closeThis'])

const { showThis } = toRefs(props)

function closeThis() {
  emit('update:showThis', false)
  emit('closeThis', true)
  tool.reloadWeb()
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
@import '@/assets/scss/_make.scss';
.pay-method {
  position: fixed;
  top: 13vh;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 110;
  color: #0c0d0f;
  text-align: center;
  background: linear-gradient(110deg, #f3f3f5 1.63%, #f7fafa 67.24%, #eef4f2 106.47%);
  overflow: hidden;
  @include responsive-style(
    (
      width: 794px,
      height: 572px,
      padding: 25px 0,
      border-radius: 6px,
      font-size: 14px
    )
  );

  .close {
    position: absolute;
    cursor: pointer;
    box-sizing: content-box;
    color: #979797;
    @include responsive-style(
      (
        top: 14px,
        right: 14px,
        width: 24px,
        height: 24px,
        padding: 8px
      )
    );

    &:hover {
      color: $--themecolor;
    }
  }

  .icon {
    margin: 0 auto;
    box-sizing: content-box;
    @include responsive-style(
      (
        width: 140px,
        height: 125px,
        padding: 23px 0
      )
    );
  }

  .main_title {
    font-weight: 500;
    @include responsive-style(
      (
        margin-bottom: 10px,
        font-size: 20px
      )
    );
  }

  .vice_title {
    color: #5c6470;
  }

  .return_box {
    display: flex;
    align-items: center;
    justify-content: center;
    @include responsive-style(
      (
        margin-top: 20px
      )
    );

    .btn {
      display: block;
      text-align: center;
      color: $--themecolor;
      line-height: 1.5;
      font-weight: 500;
      cursor: pointer;
      @include responsive-style(
        (
          width: 120px,
          height: 40px,
          padding: 6px 0,
          border-radius: 8px,
          border: 1px solid $--themecolor,
          font-size: 16px
        )
      );

      &.open_order {
        color: rgba(255, 255, 255, 0.9);
        background-color: #147aff;
        @include responsive-style(
          (
            margin-left: 20px
          )
        );
      }
    }
  }

  .dashed-line {
    @include responsive-style(
      (
        width: 666px,
        height: 1px,
        margin: 20px auto,
        border: 1px dashed #e4e4e4
      )
    );
  }

  .code_box {
    background: #fdfdfd;
    margin: 0 auto;
    text-align: center;
    @include responsive-style(
      (
        width: 290px,
        padding: 14px 0,
        border-radius: 10px,
        border: 1px dashed #e4e4e4
      )
    );

    .code_title {
      color: #0c0d0f;
      font-weight: 500;
      @include responsive-style(
        (
          margin-bottom: 10px,
          font-size: 12px
        )
      );
    }

    figure.down_app_code {
      @include make-backgroundimage-custom(
        lg,
        (
          name: '@/assets/img/cad/down_app_code',
          extname: 'png',
          width: 102,
          height: 102
        )
      );
      @include make-backgroundimage-custom(
        xl,
        (
          name: '@/assets/img/cad/down_app_code-xl',
          extname: 'png',
          width: 122,
          height: 122
        )
      );
      @include make-backgroundimage-custom(
        mx,
        (
          name: '@/assets/img/cad/down_app_code-mx',
          extname: 'png',
          width: 204,
          height: 204
        )
      );
    }

    .code_intro {
      color: #5c6470;
      @include responsive-style(
        (
          margin-top: 8px,
          font-size: 12px
        )
      );
    }
  }
}
</style>
